import { h, Fragment } from "preact";
import { useEffect, useState } from "preact/hooks";
import { Scrollbar, FreeMode, Mousewheel } from "swiper/modules";
import ProductCard from "./product-card.jsx";
import storefront from "../storefront";
import * as queries from "../storefront/queries";

const ProductCarousel = ({ products, swiperParams = [], cardStyle }) => {
  const [validProducts, setValidProducts] = useState([]);

  // Get Products By ID Sets based on Props
  const getProductsByIds = async () => {
    const response = await storefront.request({
      query: queries.products,
      variables: {
        ids: products.map(({ id }) => encodeId(id, "Product")),
      },
    });
    if (response?.data?.nodes) {
      const productData = {};

      response.data.nodes.forEach((product) => {
        if (!product) return;

        productData[product.id] = product;
      });

      const data = products
        .map(({ id, preselect_color }) => {
          const gid = `gid://shopify/Product/${id}`;

          if (!(gid in productData)) return null;

          return {
            product: productData[gid],
            preselect_color,
          };
        })
        .filter((item) => item !== null);

      setValidProducts(data);
    }
  };

  console.log("productData", validProducts);

  useEffect(() => {
    getProductsByIds();
  }, []);

  return (
    <swiper-container
      {...swiperParams}
      modules={[FreeMode, Mousewheel, Scrollbar]}
      className="product-carousel__swiper-container"
    >
      {validProducts.map(({ product, preselect_color }) => {
        return (
          <swiper-slide className="product-carousel__slide">
            <ProductCard
              data={product}
              preselectColor={preselect_color}
              gallery={false}
              cardStyle={cardStyle}
            />
          </swiper-slide>
        );
      })}
    </swiper-container>
  );
};

export default ProductCarousel;
